import React from 'react';

export const AuthPage = React.lazy(() => import('@features/auth/pages/auth/auth'));
